<!--
 * @Description: 加油券订单详情
 * @Author: yl
 * @Date: 2021-06-10 11:55:45
 * @LastEditTime: 2021-06-16 14:02:33
 * @LastEditors: yl
-->
<template>
    <div class="topbar-container">
        <div class="buy-container">
            <div class="scrollbar-container">
                <!-- 结果信息 -->
                <div class="line" v-if="isConsequence"></div>
                <div class="countdown bv bc" v-if="isExchangeingOil">
                    <div class="bh">
                        <div class="ico-time bg-contain fz_40"></div>正在充值中
                    </div>
                </div>
                <div class="countdown bv bc" v-else-if="isConsequence">
                    <div class="bh">
                        <div class="ico-win bg-contain fz_40"></div>充值成功
                    </div>
                </div>
                <!-- 待支付信息 -->
                <div class="line" v-if="isPay"></div>
                <div class="countdown bv bc" v-if="isPay">
                    <div class="bh">
                        <div class="ico-time bg-contain fz_40"></div>等待买家付款
                    </div>
                    <div class="fz_30 time">剩余{{formatSeconds(info.leftExpireSec)}}自动关闭</div>
                </div>
                <div class="line"></div>
                <!-- 基础信息 -->
                <div class="address-list">
                    <!-- vip重置信息 -->
                    <div class="address-list-item" v-if="isVip">
                        <div class="item bh bstart">
                            <div class="bg-contain ico-location"></div>
                            <span
                                class="fz_30"
                            >{{info.ordersMemberRecharge.numberType}}：{{info.ordersMemberRecharge.number}}</span>
                        </div>
                    </div>
                    <!-- 油卡信息 -->
                    <div class="address-list-item" v-else-if="isOil">
                        <div class="item bh bstart">
                            <div class="bg-contain" :class="oilShow.ico"></div>
                            <span class="fz_30">{{oilShow.text}}：{{info.ordersOilCard.account}}</span>
                        </div>
                    </div>
                    <div class="address-list-item" v-else-if="info.orderCusAddr">
                        <div class="item bh bstart">
                            <div class="bg-contain ico-location"></div>
                            <div class="b1">
                                <div class="bh bstart fz_30">
                                    {{info.orderCusAddr.name}}&emsp;
                                    {{info.orderCusAddr.telephone}}
                                </div>
                                <div class="address fz_28">{{info.orderCusAddr.address}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 虚拟商品信息 -->
                    <div class="address-list-item" v-else>
                        <div class="p30_0" v-if="info.orderStatus === 4">
                            <couponKeys :code='info.ordersRedeemCodeForH5.redeemCodeList[0]'></couponKeys>
                        </div>
                        <!-- <div class="item bh bstart">
                            <div class="bg-contain ico-call"></div>
                            <span
                                class="fz_30"
                            >下单电话：{{info.redeemCodeBendIngTelephone||info.rechargeTelephone}}</span>
                        </div> -->
                    </div>
                </div>
                <div v-if="info.orderStatus === 4" class="line"></div>
                <!-- 商品信息 -->
                <div class="buy-list">
                    <div class="bh bstart group-title">
                        <div class="bg-contain ico-good"></div>
                        <div class="fz_34">{{info.orderTypeStr}}</div>
                    </div>
                    <div
                        v-for="(item,index) in info.orderGoodsItemsList"
                        :key="index"
                        class="cart-list-item"
                    >
                        <div class="item bh">
                            <div
                                class="img bg-100 r6"
                                :style="{backgroundImage: 'url(' + item.image + ')'}"
                            ></div>
                            <div class="content b1">
                                <div class="fz_30">{{item.name}}</div>
                                <div class="text fz_30 bh bstart">
                                    <div class="bg-contain ico-maintenance"></div>
                                    <span class="c_red">{{item.price}}</span>
                                    <div class="b1 tr c_red">x{{item.num}}件</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bh bstart fz_28 info" v-if="info.actualPayment>0">
                        <div class="b1">订单总价：</div>
                        {{info.actualPayment}}&ensp;{{unitName}}
                    </div>
                    <div class="bh bstart fz_28 info" v-else>
                        <div class="b1">订单总价：</div>
                        {{info.orderPayment}}&ensp;{{unitName}}
                    </div>
                    <div class="bh bstart fz_28 info">
                        <div class="b1">
                            <span v-if="isPay">应付款：</span>
                            <span v-else>实付款：</span>
                        </div>
                        <span class="c_red">{{info.orderPayment}}</span>
                        &ensp;{{unitName}}
                    </div>
                </div>
                <div class="line"></div>
                <!-- 订单信息 -->
                <div class="orderInfo">
                    <div class="fz_34 title">订单信息</div>
                    <div class="bh fz_28 text">
                        <div class="b1">订单编号：</div>
                        {{info.ordersInfo.orderCode}}
                    </div>
                    <div class="bh fz_28 text" v-if="!isPay">
                        <div class="b1">付款方式：</div>
                        {{info.ordersInfo.paymentTypeStr}}
                    </div>
                    <div class="bh fz_28 text">
                        <div class="b1">创建时间:</div>
                        {{info.ordersInfo.createTime}}
                    </div>
                    <div class="bh fz_28 text" v-if="info.ordersInfo.paymentTime">
                        <div class="b1">支付时间:</div>
                        {{info.ordersInfo.paymentTime}}
                    </div>
                    <div class="bh fz_28 text" v-if="info.ordersInfo.closeTime">
                        <div class="b1">成交时间:</div>
                        {{info.ordersInfo.closeTime}}
                    </div>
                    <div class="bh fz_28 text" v-if="info.ordersInfo.massage">
                        订单备注：
                        <div class="b1 tr breakword">
                            <span class="align-content">{{info.ordersInfo.massage}}</span>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <!-- 物流信息 -->
                <div
                    class="orderInfo"
                    v-if="!isDriving&&info.ordersShipInfo&&info.ordersShipInfo.shippingCode"
                >
                    <div class="fz_34 title bh bc">
                        <div class="b1">物流信息</div>
                    </div>
                    <div class="bh fz_28 text">
                        <div class="b1">物流公司：</div>
                        {{info.ordersShipInfo.shippingName}}
                    </div>
                    <div class="bh fz_28 text" v-if="!isPay">
                        <div class="b1">快递单号：</div>
                        {{info.ordersShipInfo.shippingCode}}
                    </div>
                    <div class="bh bend doubleBtn-wrap">
                        <van-button
                            class="btn btn-pay-mini"
                            v-on:click.native="onCopyClick(info.ordersShipInfo.shippingCode)"
                        >复制单号</van-button>&emsp;
                        <van-button class="btn btn-pay-mini" v-on:click.native="onLinkClick">快递查询</van-button>
                    </div>
                </div>
                <div
                    class="line"
                    v-if="!isDriving&&info.ordersShipInfo&&info.ordersShipInfo.shippingCode"
                ></div>
                <!-- 代驾劵信息 -->
                <div class="orderInfo" v-if="isUser">
                    <div class="fz_34 title">劵信息</div>
                    <div class="bh fz_28 text">
                        <div class="b1">下单手机：</div>
                        {{info.redeemCodeBendIngTelephone}}
                    </div>
                    <div class="bh fz_28 text" v-if="!isPay">
                        <div class="b1">有效期：</div>
                        {{info.ordersRedeemCodeForH5.expirationDate}}
                    </div>
                    <!-- <div class="bh fz_28 text">
                        <div class="b1">劵状态：</div>
                        {{info.ordersRedeemCodeForH5.statusStr}}
                    </div> -->
                </div>
                <div class="line" v-if="isUser"></div>
                <!-- <div class="orderInfo" v-if="isUser">
                    <div class="fz_34 title">使用说明</div>
                    <div class="fz_28 text">1.电子劵不可叠加使用，单次使用一张，用后余额作废；</div>
                    <div class="fz_28 text">2.电子劵不可透支，不挂失，不找零，不开具发票；</div>
                    <div class="fz_28 text">3.使用e代驾APP或者e代驾小程序均可下单呼叫代驾；</div>
                    <div class="fz_28 text">4.使用下单手机号呼叫代驾，结束后减免相应的费用；</div>
                    <div class="fz_28 text">5.代驾劵有效期为1年，过期不补；</div>
                </div> -->
                <div class="line" v-if="isUser"></div>
                <!-- 油卡卡密信息 -->
                <div class="orderInfo" v-if="isExchangeOil&&!isExchangeingOil&&info.orderStatus != 0">
                    <div class="fz_34 title">卡密信息</div>
                    <div class="bh fz_28 text">
                        <div class="b1">卡密有效期：</div>
                        {{info.ordersOilCard.cardDeadline}}
                    </div>
                    <div class="bh fz_28 text">
                        <div class="b1">兑换卡密：</div>
                        {{info.ordersOilCard.cardSecret}}
                    </div>
                    <div class="bh bend doubleBtn-wrap">
                        <van-button
                            class="btn btn-pay-mini"
                            v-on:click.native="onCopyClick(info.ordersOilCard.cardSecret)"
                        >复制卡密</van-button>&emsp;
                        <van-button
                            class="btn btn-pay-mini"
                            v-on:click.native="onExchangeClick"
                        >立即兑换</van-button>
                    </div>
                </div>
                <div class="line" v-if="isExchangeOil"></div>
            </div>
            <div class="buybar bh bend">
                <van-button
                    class="btn btn-goodcart"
                    v-if="isUpAddress"
                    @click="go('CartOrderAddress',{info:info,id:id})"
                >修改地址</van-button>
                <van-button class="btn btn-goodcart" @click="onTelClick">联系商家</van-button>
                <van-button
                    class="btn btn-goodbuy"
                    v-if="isReceive"
                    @click="onReceiveClick(id,info.redeemCodeBendIngTelephone)"
                >领取使用</van-button>
                <van-button
                    class="btn btn-goodbuy"
                    v-if="isCharge"
                    @click="onChangeClick('close')"
                >确认收货</van-button>
                <van-button
                    class="btn btn-goodcart"
                    v-if="isPay"
                    @click="onChangeClick('cancel')"
                >取消订单</van-button>
                <van-button class="btn btn-goodbuy" v-if="isPay" @click="onSaveClick">支付订单</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import { orderInfo, changeOrder, checkUpAddress } from "@/api/cart";
import VueClipboard from "vue-clipboard2";
import Vue from "vue";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
import { callTel } from "@/utils/bridge";
import couponKeys from "@/views/user/coupons/components/gasCouponKeys";
export default {
    mixins: [routeCache, user],
    name: "CartOrderInfo",
    components: { couponKeys },
    data() {
        return {
            unitName: "车主币",
            id: null,
            isPay: false,
            // 是否可以更新地址
            isUpAddress: false,
            info: { orderCusAddr: {}, ordersInfo: {}}
        };
    },
    computed: {
        // 订单类型
        orderType() {
            return this.info.orderType;
        },
        // 是否是可使用的劵
        isUser() {
            return this.orderType == 2;
        },
        // 是否虚拟物品
        isDriving() {
            return this.orderType != 0;
        },
        // 是否显示领取按钮
        isReceive() {
            return this.isUser && this.info.orderStatus == 3;
        },
        // 是否可以收货
        isCharge() {
            return this.orderType == 0 && this.info.orderStatus == 3;
        },
        // 是否油卡充值
        isOil() {
            return this.orderType == 7;
        },
        // 是否会员充值
        isVip() {
            return this.orderType == 6;
        },
        // 油卡是否正在充值
        isExchangeingOil() {
            const orderStatus = this.info.orderStatus;
            if (this.isExchangeOil && orderStatus != 5 && orderStatus != 0) {
                const cardSecret = this.info.ordersOilCard.cardSecret;
                return !(cardSecret && cardSecret != -1);
            }
            return false;
        },
        // 是否兑换油卡卡密
        isExchangeOil() {
            const me = this;
            if (me.isOil) {
                return me.info.ordersOilCard.accountType == 1;
            }
            return false;
        },
        // 油卡重置时显示文字
        oilShow() {
            return this.isExchangeOil
                ? {
                      text: "手机号",
                      ico: "ico-call"
                  }
                : {
                      text: "中石化油卡卡号",
                      ico: "ico-location"
                  };
        },
        // 是否显示结果信息
        isConsequence() {
            // 订单为已完成
            // console.log(this.info);
            if (this.info.orderStatus == 4) {
                // 油卡订单和会员充值订单
                return this.isOil || this.isVip;
            }
            return false;
        }
    },
    watch: {
        isExchangeingOil(v) {
            const me = this;
            if (v) {
                // 如果定时器不存在
                if (!me.timer) {
                    // console.log('定时刷新')
                    // 每隔10秒刷新一次数据，检查是否充值成功
                    me.timer = setInterval(() => {
                        me.userLoginend();
                    }, 10000);
                }
            } else {
                me.endTimer();
            }
        }
    },
    destroyed() {
        // console.log("destroyed");
        this.endTimer();
    },
    methods: {
        onTelClick() {
            callTel(this.$store.state.tell);
        },
        endTimer() {
            const me = this;
            if (me.timer) {
                // 清除定时器
                clearInterval(me.timer);
                me.timer = null;
            }
        },
        // 秒转时分
        formatSeconds(time) {
            const min = Math.floor(time % 3600);
            return `${Math.floor(time / 3600)}小时${Math.floor(min / 60)}分`;
        },
        // 获取用户数据后执行
        userLoginend() {
            const me = this;
            me.id = me.getCache().id;
            orderInfo(me.id).then(res => {
                const data = res.data;
                me.isPay = data.orderStatus === 0;
                if (data.ordersInfo) {
                    me.unitName =
                        data.ordersInfo.paymentTypeStr == "微信支付"
                            ? "元"
                            : "车主币";
                }
                me.info = data;
            });
            checkUpAddress(me.id).then(res => {
                me.isUpAddress = res.data;
            });
        },
        // 改变订单状态
        onChangeClick(state) {
            const me = this;
            let message = "确定取消订单？";
            if (state == "close") {
                message = "确定收货？";
            }
            me.dialog
                .confirm({
                    title: "提示",
                    message: message
                })
                .then(() => {
                    changeOrder(me.id, state).then(res => {
                        // 标识需要更新用户订单列表数据
                        me.$store.state.cart.isUpdateUserOrder = true;
                        me.$router.go(-1);
                    });
                });
        },
        // 支付
        onSaveClick() {
            this.$router.replace({
                name: "CartOrderPay",
                params: {
                    orderCode: this.info.ordersInfo.orderCode,
                    orderPayment: this.info.orderPayment
                },
                query: { orderEndPage: 'CartOrderGasCouponConsequence' }
            });
        },
        // 复制
        onCopyClick(v) {
            const me = this;
            me.$copyText(v).then(
                function(e) {
                    me.toast.success("复制成功");
                },
                function(e) {
                    console.log(e);
                }
            );
        },
        // 跳转
        onLinkClick() {
            this.bannerGo("http://www.kuaidi100.com");
        },
        // 兑换
        onExchangeClick() {
            this.bannerGo("https://dwz.cn/I8D6Hmtg");
        },
        // 兑换
        onReceiveClick(orderId, telephone) {
            this.$router.push({
                name: "CartOrderExchange",
                params: {
                    orderId,
                    telephone
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.countdown {
    background: #fff;
    padding: 60px 0;
    .ico-time,
    .ico-win {
        width: 51px;
        height: 51px;
        margin-right: 12px;
    }
    .time {
        color: #333;
        padding-top: 30px;
    }
}
.buy-container {
    background-color: #f1f2f3;
}
.buy-list {
    background: #fff;
    padding-bottom: 60px;
}
.info {
    padding: 40px 30px 0 30px;
}
.orderInfo {
    padding: 60px 30px;
    background: #fff;
    color: #666;
    .title {
        color: #000;
    }
    .text {
        padding-top: 30px;
    }
}
.doubleBtn-wrap {
    padding: 40px 0 20px;
}
.buybar {
    .text {
        margin-right: 40px;
    }
    .btn {
        width: 160px;
        margin-right: 20px;
        font-size: 28px;
    }
}
</style>
